// extracted by mini-css-extract-plugin
module.exports = {"titleIn":"block_titleIn_3Fbxb","delimiters":"block_delimiters_Ge4fh","layout":"block_layout_3Wxz0","sheet":"block_sheet_1F4DP"};